module.exports = __webpack_public_path__ + "img/background_c4-1-1_mobile.652492b6.jpg";